import React, { useMemo } from "react";
import { Col, Row, Button, Table } from "reactstrap";
import { useDispatch } from "react-redux";
import { downloadJobSourceCsvRequest } from "../../../redux/recruiter/job_source/actions";
import { capitalize } from "../../Common/CommonFunction";
import { jobsourceOptions } from "../../../Constant";
import NoDataFound from "../../Common/NoDataFound";

/** Source types that get their own column (excludes "All") */
const SOURCE_COLUMNS = jobsourceOptions.filter((o) => o.value);

const JobSourceDatatable = ({ jobSourceData, formData }) => {
  const dispatch = useDispatch();

  const rawList = Array.isArray(jobSourceData?.data) ? jobSourceData.data : [];

  const { tableRows, hasRows } = useMemo(() => {
    if (!rawList.length) {
      return { tableRows: [], hasRows: false };
    }

    const byJob = new Map();

    for (const row of rawList) {
      const name = (row.job_name || "-").trim() || "-";
      if (!byJob.has(name)) {
        const sources = {};
        SOURCE_COLUMNS.forEach((col) => {
          sources[col.value] = 0;
        });
        byJob.set(name, { job_name: name, sources, total: 0 });
      }

      const rec = byJob.get(name);
      const c = parseInt(row.counts, 10) || 0;
      const src = row.source;

      rec.total += c;
      if (src && Object.prototype.hasOwnProperty.call(rec.sources, src)) {
        rec.sources[src] += c;
      }
    }

    const rows = Array.from(byJob.values()).sort((a, b) =>
      a.job_name.localeCompare(b.job_name, undefined, {
        sensitivity: "base",
      })
    );

    return { tableRows: rows, hasRows: rows.length > 0 };
  }, [rawList]);

  if (!hasRows) {
    return (
      <div className="mt-3">
        <NoDataFound />
      </div>
    );
  }

  const handleExport = () => {
    const obj = {
      source: formData.jobSource,
      job_id: formData.jobId,
      startDate: formData.dateRange.startDate.toISOString(),
      endDate: formData.dateRange.endDate.toISOString(),
    };

    dispatch(downloadJobSourceCsvRequest(obj));
  };

  return (
    <>
      <Row className="d-flex justify-content-start mb-3 mt-3">
        <Col xs="auto">
          <Button color="primary" onClick={handleExport}>
            Export
          </Button>
        </Col>
      </Row>
      <Row>
        <Col xs="12" className="box-col-12 xl-100">
          <div className="table-responsive">
            <Table striped bordered responsive className="mb-0">
              <thead>
                <tr>
                  <th style={{ minWidth: "200px" }}>Job Name</th>
                  {SOURCE_COLUMNS.map((col) => (
                    <th key={col.value} className="text-center">
                      {col.label}
                    </th>
                  ))}
                  <th className="text-center" style={{ fontWeight: 700 }}>
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {tableRows.map((row, index) => (
                  <tr key={`${row.job_name}-${index}`}>
                    <td>{capitalize(row.job_name) || "-"}</td>
                    {SOURCE_COLUMNS.map((col) => (
                      <td key={col.value} className="text-center">
                        {row.sources[col.value] ?? 0}
                      </td>
                    ))}
                    <td
                      className="text-center"
                      style={{ fontWeight: 600 }}
                    >
                      {row.total}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default JobSourceDatatable;
